import jQuery from "jquery";


jQuery(document).ready(function() {
  $('[data-youtube]').youtube_background();
});